import { render, staticRenderFns } from "./ProviderDetailOPPendingComponent.vue?vue&type=template&id=c15d1d00&"
import script from "./ProviderDetailOPPendingComponent.vue?vue&type=script&lang=js&"
export * from "./ProviderDetailOPPendingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports